module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Layout/Layout-top-panel-2-97f8fd4b676998ac44f9186b75ccc1a0.svg";